import { SheetDefaults } from '../constants/sheetDefaults';

export const getSheetCellsLeft = (
  stageWidth: number,
  rowHeaderWidth: number,
  isRtl: boolean
) => (isRtl ? stageWidth - rowHeaderWidth : rowHeaderWidth);

export const getAfterFreezeX = (
  freezedColsSum: number,
  x: number,
  isRtl: boolean,
  zoom: number
) => {
  const dir = isRtl ? -1 : 1;

  const visibleSize = SheetDefaults.freezeBarHandleSize * zoom;

  return x + (freezedColsSum + visibleSize) * dir;
};
